import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { scAxiosAdmin, scAxios } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroupFunctional from "../RadioGroupFunctional";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import roomCategory from "../../assets/data/room-service.json";
import rooms from "../../assets/data/rooms.json";
import { error } from "jquery";
import banner_img from "../../images/banner-profile.jpg";
import Lightbox from "react-image-lightbox";

const RoomCategory = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const handleClickOnImage = (data) => {
    setIsOpen(true);
    setSelectedImage(data);
  };
  return (
    <div>
      <SEO
        title="Room Category | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Room Category"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="termscondbody mt-5 pb-5">
          <div className="container p-3">
            <h2 className="text-secondary mb-5">ROOM CATEGORY</h2>
            <div className="row g-3 w-100 mx-auto">
              <div className="container">
                {rooms.map((data, index) => (
                  <div
                    className="row mb-5"
                    style={{ backgroundColor: "#ffffff" }}
                  >
                    <div className="col-md-8">
                      <div
                        key={index}
                        className="roomContainer px-0 mb-5"
                        onClick={() => handleClickOnImage(data.file)}
                      >
                        <div
                          className="d-flex align-items-center text-secondary"
                          style={{ height: "70px", backgroundColor: "#ffffff" }}
                        >
                          <h5 className="ps-2">{data.type}</h5>
                        </div>
                        <a className="px-0 d-flex justify-content-center">
                          <img
                            className="border"
                            src={require(`../../assets/images/Rooms/${data.file}.jpg`)}
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div
                        key={index}
                        className="roomContainer d-flex justify-content-around align-items-center h-100"
                      >
                        <table className="table table-bordered h-75 mt-4">
                          <thead>
                            <tr>
                              <th scope="col">Price</th>
                              <th scope="col">Amenities</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">{data.price}</th>
                              <td>N/A</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <table className="table table-hover table-bordered roomTable mb-5">
                <thead>
                  <tr className="table-active">
                    <th scope="col">SL NO</th>
                    <th scope="col">TYPE OF CABIN/ROOM</th>
                    <th scope="col">RENT PER DAY (BDT)</th>
                  </tr>
                </thead>
                <tbody>
                  {roomCategory.map((data, index) => (
                    <tr key={index}>
                      <th scope="row">{data.Sl_No}</th>
                      <td>{data.typeOfRoom}</td>
                      <td>{data.rentPerDay}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* {rooms.map((data, index) => (
              <div
                key={index}
                className="roomContainer px-0 mb-5"
                onClick={() => handleClickOnImage(data.file)}
              >
                <div
                  className="d-flex align-items-center text-secondary"
                  style={{ height: "70px", backgroundColor: "#ffffff" }}
                >
                  <h5 className="ps-2">{data.type}</h5>
                </div>
                <a className="px-0 d-flex justify-content-center">
                  <img
                    src={require(`../../assets/images/Rooms/${data.file}.jpg`)}
                    alt=""
                  />
                </a>
              </div>
            ))} */}
              {isOpen && (
                <Lightbox
                  style={{ zIndex: "0" }}
                  mainSrc={require(`../../assets/images/Rooms/${selectedImage}.jpg`)}
                  onCloseRequest={() => setIsOpen(false)}
                ></Lightbox>
              )}
            </div>
          </div>
        </section>
      </div>
      <Route component={Footer} />
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default RoomCategory;



// WEBPACK FOOTER //
// ./src/component/frontend/RoomCategory.js